/* eslint-disable camelcase */
import { DEFAULT_TILE_RESOLUTION } from "../constants.js";
import { baseSource } from "./base-source.js";
export const vectorQuerySource = async function (options) {
    const { columns, filters, spatialDataColumn = 'geom', sqlQuery, tileResolution = DEFAULT_TILE_RESOLUTION, queryParameters } = options;
    const urlParameters = {
        spatialDataColumn,
        spatialDataType: 'geo',
        tileResolution: tileResolution.toString(),
        q: sqlQuery
    };
    if (columns) {
        urlParameters.columns = columns.join(',');
    }
    if (filters) {
        urlParameters.filters = filters;
    }
    if (queryParameters) {
        urlParameters.queryParameters = queryParameters;
    }
    return baseSource('query', options, urlParameters);
};
